import {
  Alert,
  Box,
  CircularProgress,
  Container,
  Divider,
  IconButton,
  Slide,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import "./PublishPost.scss";
import LabelledInput from "../LabelledInput/LabelledInput";
import TextArea from "../TextArea/TextArea";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import { useRef } from "react";
import { useEffect } from "react";
import {
  getPreSignedURL,
  getPublishStatus,
  postMedia,
  publish,
} from "../../../utils/apiHelperInternal";
import CircularProgressWithLabel from "../../CircularProgressWithLabel/CircularProgressWithLabel";
import {
  PHYLLO_PUBLISH_FAILURE_STATUS,
  PHYLLO_PUBLISH_READY_STATUS,
  PHYLLO_PUBLISH_SUCCESS_STATUS,
  PUBLISH_PLATFORM_MEDIA_MAPPING,
  SUCCESS_MESSAGE_MAPPING,
} from "../../../utils/constants";

function SlideTransition(props) {
  return <Slide {...props} direction="down" />;
}
function PublishPost({ accountInfo, selectedPlatform }) {
  const mobileBreakPoint = useMediaQuery("(max-width:430px)");
  const [previewMedia, setPreviewMedia] = useState(null);
  const publishBtn = useRef();
  const fileInput = useRef();
  const [postTitle, setPostTitle] = useState(null);
  const [postDesc, setPostDesc] = useState(null);

  const [previewImg, setPreviewImg] = useState(null);
  const [previewVideo, setPreviewVideo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorPublishing, setErrorPublishing] = useState(false);
  const [isUploadingMedia, setIsUploadingMedia] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [selectedWorkPlatform, setSelectedWorkPlatform] = useState(null);
  const mediaURL = useRef(null);
  const [uploadMediaProgress, setUploadMediaProgress] = useState(0);
  const [toastOpen, setToastOpen] = useState(false);
  const publishStatusPollId = useRef();
  const charLimit = 150;
  const [charcount, setCharCount] = useState(0);

  function validateMedia(file) {
    let maxSize;
    if (
      file.type.startsWith("image") &&
      selectedWorkPlatform.name === "Instagram"
    ) {
      maxSize = 8 * 1024 * 1024;
    } else {
      maxSize = 50 * 1024 * 1024;
    }
    // console.log(file);

    const allowedTypesArray =
      PUBLISH_PLATFORM_MEDIA_MAPPING[selectedWorkPlatform.name].split(",");
    if (!allowedTypesArray.includes(file.type)) {
      setErrorMsg(`Invalid file type. Please upload a file of type mp4.`);
      return false;
    }
    if (file.size > maxSize) {
      setErrorMsg(
        `The file is too large. Please upload a file of upto ${
          maxSize / (1024 * 1024)
        } MB.`
      );
      return false;
    } else {
      setErrorMsg(null);
      return true;
    }
  }

  function handleMedia(ev) {
    const [file] = ev.target.files;
    if (file && validateMedia(file)) {
      uploadMedia(file);
    }
  }

  async function uploadMedia(file) {
    // validate

    setIsUploadingMedia(true);
    publishBtn.current.setAttribute("disabled", true);

    // console.warn(file, file["type"]);
    const mediaPreview = URL.createObjectURL(file);
    // setTimeout(() => {
    //   if (file && file["type"].split("/")[0] === "image") {
    //     setIsUploadingMedia(false);
    //     publishBtn.current.removeAttribute("disabled");
    //     setPreviewImg(mediaPreview);
    //   }
    //   if (file && file["type"].split("/")[0] === "video") {
    //     setIsUploadingMedia(false);
    //     publishBtn.current.removeAttribute("disabled");
    //     setPreviewVideo(mediaPreview);
    //   }
    // }, 10000);

    const publicURLRes = await getPreSignedURL(selectedWorkPlatform.id);
    mediaURL.current = publicURLRes;
    // console.warn(publicURLRes);
    const uploadRes = await postMedia(
      publicURLRes.upload_url,
      file,
      setUploadMediaProgress
    );
    if (file && file["type"].split("/")[0] === "image") {
      setIsUploadingMedia(false);
      publishBtn.current.removeAttribute("disabled");
      setPreviewImg(mediaPreview);
    }
    if (file && file["type"].split("/")[0] === "video") {
      setIsUploadingMedia(false);
      publishBtn.current.removeAttribute("disabled");
      setPreviewVideo(mediaPreview);
    }

    // cancel upload in between
  }

  function cancelUpload() {
    // cancel req with abort controller
    setIsUploadingMedia(false);
    publishBtn.current.removeAttribute("disabled");
  }

  async function pollPublishStatus(id) {
    const statusRes = await getPublishStatus(id);
    if (
      statusRes.data.status === PHYLLO_PUBLISH_READY_STATUS ||
      statusRes.data.status === PHYLLO_PUBLISH_SUCCESS_STATUS
    ) {
      clearForm();
      setErrorPublishing(false);
      setIsLoading(false);
      setToastOpen(true);
      window.clearInterval(publishStatusPollId.current);
    } else if (statusRes.data.status === PHYLLO_PUBLISH_FAILURE_STATUS) {
      setErrorPublishing(true);
      setIsLoading(false);
      window.clearInterval(publishStatusPollId.current);
    }
  }
  async function onPublish(ev) {
    ev.preventDefault();
    // debugger;
    if (formValidation()) {
      //start publishing
      setIsLoading(true);
      setErrorPublishing(false);
      // const account_id = accountInfo.filter((acc) => acc.val.id===selectedPlatform)[0].val.account_id;
      const payload = {
        account_id: selectedPlatform,
        title: postTitle,
        description: postDesc,
        type: previewImg ? "IMAGE" : "VIDEO",
        additional_info: {},
        media: [
          {
            media_type: previewImg ? "IMAGE" : "VIDEO",
            source_media_url: mediaURL.current.download_url,
          },
        ],
      };

      if (selectedWorkPlatform.name === "Instagram") {
        if (payload.type === "VIDEO") {
          payload.type = "REELS";
        }
        payload.additional_info["share_to_feed"] = true;
      }

      const publishRes = await publish(payload);
      if (publishRes.status === 202) {
        pollPublishStatus(publishRes.data.data.id);

        const pollStartTime = Date.now();

        publishStatusPollId.current = window.setInterval(async () => {
          // debugger;
          if (Date.now() - pollStartTime <= 60000)
            pollPublishStatus(publishRes.data.data.id);
        }, 3000);

        //sucess
      } else {
        //failed
        setIsLoading(false);
        setErrorPublishing(true);
      }

      // setTimeout(() => {
      //   setIsLoading(false);
      //   setErrorPublishing(true);
      // }, 5000);
    }
  }

  function clearForm() {
    setPostTitle(null);
    setPostDesc(null);
    setCharCount(0);
    setPreviewImg(null);
    setPreviewVideo(null);
    setUploadMediaProgress(0);
  }

  function formValidation() {
    const postMedia = previewImg || previewVideo;
    if (charcount > charLimit) {
      setErrorMsg("Character limit exceeded.");
      return false;
    }
    if (!postMedia) {
      setErrorMsg("Add media is required field.");
      return false;
    } else {
      setErrorMsg(null);
      return true;
    }
  }
  useEffect(() => {
    if (selectedPlatform) {
      setSelectedWorkPlatform(
        accountInfo.filter((acc) => acc.val.id === selectedPlatform)[0].val
          .work_platform
      );
    }

    return () => {
      //clean up
      if (publishStatusPollId.current) {
        window.clearInterval(publishStatusPollId);
      }
    };
  }, [selectedPlatform]);
  return (
    <Box
      sx={
        mobileBreakPoint
          ? {
              width: "100%",
              backgroundColor: "#f7f7fb",
            }
          : {
              width: "100%",
              padding: "24px 0px 16px 0px",
              backgroundColor: "#f7f7fb",
            }
      }
    >
      <Box
        sx={
          mobileBreakPoint
            ? {
                padding: "26px 20px 32px 20px",
                width: "100%",
                height: errorMsg ? "760px" : "680px",
                backgroundColor: "#FFFFFF",
                borderRadius: "8px",
              }
            : {
                padding: "40px 48px",
                width: "100%",
                height: errorMsg ? "550px" : "500px",
                backgroundColor: "#FFFFFF",
                borderRadius: "8px",
              }
        }
      >
        {/* loading part */}
        {isLoading && (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <CircularProgress
              sx={{
                color: "#B9B8C0",
              }}
            />
            <h4
              style={{
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: "600",
                fontSize: "16px",
                lineHeight: "100%",
                textAlign: "center",
                color: "#313544",
                marginTop: "32px",
                marginBotton: "16px",
              }}
            >
              Publishing your post
            </h4>
            <p
              style={{
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "12px",
                lineHeight: "150%",
                textAlign: "center",
                color: "#62616F",
              }}
            >
              This might take some time, please wait while we do the magic!
            </p>
          </Box>
        )}
        {/* error part */}
        {errorPublishing && (
          <Box
            className="publish-error"
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <IconButton
              aria-label="delete"
              onClick={() => {
                clearForm();
                setIsLoading(false);
                setErrorPublishing(false);
              }}
              sx={{
                width: "40px",
                height: "40px",
              }}
            >
              <CancelIcon
                sx={{
                  width: "40px",
                  height: "40px",
                  fill: "#D4D3D9",
                }}
              />
            </IconButton>
            <h4
              style={{
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: "600",
                fontSize: "16px",
                lineHeight: "130%",
                textAlign: "center",
                color: "#313544",
                marginTop: "28px",
              }}
            >
              Uh-oh! We had some trouble publishing your post
            </h4>
            <p
              style={{
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "12px",
                lineHeight: "150%",
                textAlign: "center",
                color: "#62616F",
              }}
            >
              You can try publishing again in some time, or create a new post.
            </p>
            <Box
              sx={{
                display: "flex",
                gap: "12px",
                marginTop: "16px",
              }}
            >
              <Button
                className="tryButton"
                variant="contained"
                sx={{
                  background: "#F9B90B",
                  borderRadius: "8px",
                  color: "#313544",
                  padding: "12px 34px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "600",
                  fontSize: "14px",
                  lineHeight: "100%",
                  boxShadow: "none",
                }}
                onClick={onPublish}
              >
                Try again
              </Button>
              <Button
                className="createButton"
                variant="contained"
                sx={{
                  background: "#FFFFFF",
                  color: "#313544",
                  padding: "12px 24px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "600",
                  fontSize: "14px",
                  lineHeight: "100%",
                  boxShadow: "none",
                  border: "1px solid #A09FA9",
                  borderRadius: "8px",
                }}
                onClick={() => {
                  clearForm();
                  setIsLoading(false);
                  setErrorPublishing(false);
                }}
              >
                Create new post
              </Button>
            </Box>
          </Box>
        )}
        {/* publish post form */}
        {!isLoading && !errorPublishing && selectedWorkPlatform && (
          <form onSubmit={onPublish}>
            <Box className="publish-title-container">
              <BorderColorIcon
                sx={
                  mobileBreakPoint
                    ? {
                        color: "#313544",
                        width: "20px",
                        height: "20px",
                      }
                    : {
                        color: "#313544",
                        width: "24px",
                        height: "24px",
                      }
                }
              />
              <Typography
                className="publishTitle"
                sx={
                  mobileBreakPoint
                    ? {
                        fontFamily: "Inter",
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: "100%",
                        color: "#313544",
                        marginLeft: "10px",
                      }
                    : {
                        fontFamily: "Inter",
                        fontStyle: "normal",
                        fontWeight: 600,
                        fontSize: "20px",
                        lineHeight: "100%",
                        color: "#313544",
                        marginLeft: "15px",
                      }
                }
              >
                Create a post
              </Typography>
            </Box>
            <hr
              style={
                mobileBreakPoint
                  ? {
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderColor: "rgba(0, 0, 0, 0.12)",
                      margin: "16px 0px",
                      marginLeft: "-20px",
                      marginRight: "-20px",
                    }
                  : {
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderColor: "rgba(0, 0, 0, 0.12)",
                      margin: "16px 0px",
                    }
              }
            />
            <Box
              sx={
                mobileBreakPoint
                  ? {
                      display: "flex",
                      width: "100%",
                      flexDirection: "column",
                      paddingTop: "20px",
                    }
                  : {
                      display: "flex",
                      gap: "32px",
                      width: "100%",
                      paddingTop: "8px",
                    }
              }
            >
              <Box sx={mobileBreakPoint ? { width: "100%" } : { width: "50%" }}>
                <LabelledInput
                  label={"Post title"}
                  name={"title"}
                  placeholder={"This an awesome post"}
                  type={"text"}
                  id={"publish-input"}
                  onChange={(ev) => setPostTitle(ev.target.value)}
                  value={postTitle}
                ></LabelledInput>
                <TextArea
                  placeholder={"So hear me out..."}
                  label={"Type your post"}
                  name={"post message"}
                  value={postDesc}
                  charLimit={charLimit}
                  charCount={charcount}
                  setCharCount={setCharCount}
                  setDescVal={setPostDesc}
                />
                {errorMsg && !mobileBreakPoint && (
                  <Alert severity="error" sx={{ marginTop: "10px" }}>
                    {errorMsg}
                  </Alert>
                )}
                {!mobileBreakPoint && (
                  <Button
                    variant="contained"
                    sx={{
                      background: "#F9B90B",
                      borderRadius: "8px",
                      color: "#313544",
                      marginTop: "16px",
                      padding: "12px 24px",
                      textTransform: "none",
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      fontWeight: "600",
                      fontSize: "14px",
                      lineHeight: "100%",
                      boxShadow: "none",
                    }}
                    ref={publishBtn}
                    className={"publish-btn"}
                    type="submit"
                  >
                    Publish
                  </Button>
                )}
              </Box>
              <Box
                sx={
                  mobileBreakPoint
                    ? {
                        display: "flex",
                        position: "relative",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        backgroundColor: "#f6f6fb",
                        border: "1px solid #EBEBEF",
                        borderRadius: "8px",
                        cursor: "pointer",
                        height: "200px",
                        marginTop: "16px",
                      }
                    : {
                        display: "flex",
                        position: "relative",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "50%",
                        backgroundColor: "#f6f6fb",
                        border: "1px solid #EBEBEF",
                        borderRadius: "8px",
                        cursor: "pointer",
                        height: "320px",
                        marginTop: "20px",
                      }
                }
                onClick={(e) => {
                  if (e.currentTarget === e.target)
                    document.getElementById("publish-post-file").click();
                }}
              >
                {previewImg && (
                  <>
                    <img
                      id="preview-post-media"
                      width={"100%"}
                      height={"100%"}
                      src={previewImg}
                      alt="preview not supported"
                      style={{
                        opacity: "0.85",
                      }}
                    />
                    <IconButton
                      aria-label="delete"
                      sx={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                      }}
                      onClick={() => {
                        setUploadMediaProgress(0);
                        setPreviewImg(null);
                      }}
                    >
                      <CancelIcon />
                    </IconButton>
                  </>
                )}
                {previewVideo && (
                  <>
                    <video
                      width={"100%"}
                      height={"100%"}
                      controls
                      style={{
                        opacity: "0.85",
                      }}
                    >
                      <source src={previewVideo} id="video_here" />
                      Your browser does not support HTML5 video.
                    </video>
                    <IconButton
                      aria-label="delete"
                      sx={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                      }}
                      onClick={() => {
                        setUploadMediaProgress(0);
                        setPreviewVideo(null);
                      }}
                    >
                      <CancelIcon />
                    </IconButton>
                  </>
                )}
                {isUploadingMedia && (
                  <>
                    <div
                      width={"100%"}
                      height={"100%"}
                      style={{
                        backgroundColor: "#f7f6fa",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <CircularProgressWithLabel
                        sx={{
                          color: "#B9B8C0",
                        }}
                        value={uploadMediaProgress}
                      />
                      <p
                        style={{
                          marginTop: "24px",
                          fontFamily: "Inter",
                          fontStyle: "normal",
                          fontWeight: "500",
                          fontSize: "14px",
                          lineHeight: "150%",
                          textAlign: "center",
                          color: "#757480",
                        }}
                      >
                        Uploading media
                      </p>
                    </div>
                  </>
                )}
                {!previewImg && !previewVideo && !isUploadingMedia && (
                  <>
                    <IconButton
                      color="primary"
                      aria-label="upload picture"
                      component="label"
                      sx={{
                        width: "48px",
                        height: "48px",
                        border: "2px solid #EBEBEF",
                        backgroundColor: "#fffefe",
                        marginBottom: "12px",
                      }}
                    >
                      <input
                        hidden
                        accept={
                          PUBLISH_PLATFORM_MEDIA_MAPPING[
                            selectedWorkPlatform.name
                          ]
                        }
                        type="file"
                        id="publish-post-file"
                        onClick={(ev) => {
                          ev.stopPropagation();
                          ev.target.value = null;
                        }}
                        onChange={(ev) => {
                          handleMedia(ev);
                        }}
                        ref={fileInput}
                        name="media"
                        size="52428800"
                      />

                      <AddCircleIcon
                        sx={{ width: "36px", height: "36px", fill: "#D4D3D9" }}
                      />
                    </IconButton>
                    <label
                      for="publish-post-file"
                      style={{
                        fontFamily: "Inter",
                        fontStyle: "normal",
                        fontWeight: "500",
                        fontSize: "14px",
                        lineHeight: "100%",
                        textAlign: "center",
                        color: "#757480",
                      }}
                    >
                      Add media
                    </label>
                  </>
                )}
              </Box>
            </Box>
            {errorMsg && mobileBreakPoint && (
              <Alert severity="error" sx={{ marginTop: "10px" }}>
                {errorMsg}
              </Alert>
            )}

            {mobileBreakPoint && (
              <Button
                variant="contained"
                sx={{
                  background: "#F9B90B",
                  borderRadius: "8px",
                  color: "#313544",
                  marginTop: "16px",
                  padding: "12px 24px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: "600",
                  fontSize: "14px",
                  lineHeight: "100%",
                  boxShadow: "none",
                }}
                ref={publishBtn}
                className={"publish-btn"}
                type="submit"
              >
                Publish
              </Button>
            )}
          </form>
        )}
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={toastOpen}
          // message="Your post is ready! Please approve it on your TikTok app"
          message={selectedWorkPlatform && SUCCESS_MESSAGE_MAPPING[selectedWorkPlatform?.name]}
          key={"publish-toast"}
          autoHideDuration={5000}
          className="toast-msg-container"
          TransitionComponent={SlideTransition}
          onClose={() => setToastOpen(false)}
        />
      </Box>
    </Box>
  );
}

export default PublishPost;
